<template>
  <div class="cookieSetContainer">
    <div class="w200 mb20">
      <div class="mb4"><span class="red">*</span>状态：</div>
      <a-radio-group
        :options="statusOption"
        v-model:value="postParams.status"
      />
    </div>
    <div class="w400 mb20">
      <div class="mb4"><span class="red">*</span>标题：</div>
      <a-input
        v-model:value="postParams.title"
        @change="
          e => inputLengthCut({ val: e.target.value, key: 'title', len: 200 })
        "
        placeholder="请输入"
      />
    </div>
    <div class="w400 mb20">
      <div class="mb4"><span class="red">*</span>介绍文案：</div>
      <quillEditor
        v-model:value="postParams.text"
        style="height: 100px; width: 400px;"
        :options="editorOption"
      />
    </div>
    <div class="w400 mb20">
      <div class="mb4"><span class="red">*</span>不展示的路由：</div>
      <a-input
        v-model:value="postParams.filterUrl"
        placeholder="不展示的路由以；分割"
      />
    </div>
    <div class="mb100" style="margin-bottom: 200px;">
      <div class="mb4">Cookie配置：</div>
      <div>
        <draggable
          class="wrapper df"
          style="flex-wrap: wrap;"
          v-model="cookieItemList"
          @start="drag = true"
          @end="drag = false"
          item-key="index"
          :filter="'.undraggable'"
        >
          <template #item="{ element, index }">
            <div class="df">
              <div class="element" v-if="!element.isButton">
                <div>
                  <div class="title oh pr">
                    <img :src="dragIcon" style="height: 14px;" /><b
                      >Cookie{{ index + 1 }}</b
                    >
                    <a-popconfirm
                      title="是否确定删除?"
                      ok-text="确定"
                      cancel-text="取消"
                      @confirm="() => removeCookie(index)"
                      @cancel="() => {}"
                    >
                      <div
                        class="pa t2 r0 cp"
                        v-if="!element.addButton && index !== 0"
                      >
                        <delete-outlined />
                      </div>
                    </a-popconfirm>
                  </div>
                  <div class="mb20">
                    <div class="mb4"><span class="red">*</span>标题：</div>
                    <div style="background: #ffffff;">
                      <a-input
                        v-model:value="element.title"
                        placeholder="请输入"
                        @change.stop="
                          e =>
                            inputLengthCut({
                              val: e.target.value,
                              key: 'eTitle',
                              len: 100,
                              index
                            })
                        "
                      />
                    </div>
                  </div>
                  <div class="mb20">
                    <div class="mb4"><span class="red">*</span>文案：</div>
                    <div style="background: #ffffff;">
                      <quillEditor
                        v-model:value="element.text"
                        style="height: 100px; width: 280px;"
                        :options="editorOption"
                      />
                    </div>
                  </div>
                  <div class="mb20" :class="'undraggable'">
                    <div class="mb4"><span class="red">*</span>选择类型：</div>
                    <a-radio-group
                      :options="chooseTypeOption"
                      v-model:value="element.chooseType"
                    />
                  </div>
                </div>
              </div>
              <div
                class="element"
                :class="'undraggable'"
                v-if="
                  cookieItemList.length < 21 &&
                    index === cookieItemList.length - 1 &&
                    element.isButton
                "
              >
                <div class="addTopBarItem" @click.stop="addCookie">
                  + 添加
                </div>
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </div>
  </div>
  <div class="bottomBar">
    <div class="fr">
      <a-button type="default" class="mr10" @click="() => jumpPage()"
        >取消</a-button
      >
      <a-button type="primary" @click="() => saveCookie()">保存</a-button>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, provide, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import draggable from 'vuedraggable'
import { quillEditor } from 'vue3-quill'
import { DeleteOutlined } from '@ant-design/icons-vue'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
const {
  commonConfig_cookie_detail_post_,
  commonConfig_cookie_save_post_
} = useAPI(null, [7056])
export default {
  components: {
    quillEditor,
    draggable,
    DeleteOutlined
  },
  setup() {
    const state = reactive({
      dragIcon:
        'https://cdn-image.kapeixi.cn/web/42debfc3-7cc4-4563-97cf-463a8c07d271/drag.png',
      inputLengthCut: ({ val = null, key = null, len = 0, index }) => {
        if (!val) return
        let value = val.split('').splice(0, len)
        if (key === 'title') {
          state.postParams[key] = value.join('')
        } else {
          state.cookieItemList[index].title = value.join('')
        }
      },
      jumpPage: () => {
        state.router.push({
          path: 'PublicSet',
          query: { ...state.route.query }
        })
      },
      route: useRoute(),
      router: useRouter(),
      initData: () => {
        commonConfig_cookie_detail_post_({ ...state.route.query }, state)
      },
      saveCookie: () => {
        const { title, text, filterUrl } = state.postParams
        if ([null, '', undefined].includes(title)) {
          message.warning('标题不能为空！')
          return
        }
        if ([null, '', undefined].includes(text)) {
          message.warning('介绍文案不能为空！')
          return
        }
        if ([null, '', undefined].includes(filterUrl)) {
          message.warning('不展示的路由不能为空！')
          return
        }
        const cookieItemList = state.cookieItemList.filter(v => !v.isButton)
        for (let i = 0; i < cookieItemList.length; i++) {
          cookieItemList[i].orderNum = i + 1
          if ([null, '', undefined].includes(cookieItemList[i].title)) {
            message.warning(`Cookie配置 - Cookie${i + 1} 的标题不能为空！`)
            return
          }
          if ([null, '', undefined].includes(cookieItemList[i].text)) {
            message.warning(`Cookie配置 - Cookie${i + 1} 的文案不能为空！`)
            return
          }
        }
        commonConfig_cookie_save_post_(
          {
            ...state.route.query,
            ...state.postParams,
            cookieItemList
          },
          state
        )
      },
      addCookie: () => {
        if (!state.cookieItemList) {
          state.cookieItemList = []
        }
        state.cookieItemList.splice(state.cookieItemList.length - 1, 0, {
          ...state.cookieItem
        })
      },
      removeCookie: (index = 1) => {
        state.cookieItemList.splice(index, 1)
      },
      cookieItem: {
        cookieConfigId: 1,
        title: null,
        text: null,
        chooseType: 2,
        orderNum: 0
      },
      postParams: {},
      resetPostParams: {
        status: 0,
        title: null,
        text: null,
        filterUrl: null
      },
      cookieItemList: [],
      statusOption: [
        { value: 1, label: '启用' },
        { value: 0, label: '禁用' }
      ],
      chooseTypeOption: [
        { value: 1, label: '默认选择' },
        { value: 2, label: '可选择' }
      ]
    })
    watch(
      () => state.cdnList,
      (oldData, newData) => {
        console.log('oldData', oldData)
        console.log('newData', newData)
      }
    )
    onMounted(() => {
      state.postParams = { ...state.resetPostParams }
      state.initData()
    })
    provide('initState', state)
    return {
      ...toRefs(state),
      editorOption: {
        placeholder: '请输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      }
    }
  }
}
</script>
<style scoped>
.cookieSetContainer {
  padding: 15px;
  margin: 10px;
  background: #ffffff;
}

.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}

.checkTabs {
  width: 216px;
  height: 46px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
}

.checkTab {
  width: 108px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  cursor: pointer;
}

.checkTab.check {
  background: #ffffff;
}

.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.colorBlock {
  width: 50px;
  height: 24px;
  margin-right: 10px;
  display: block;
  float: left;
  margin-top: 4px;
}

.addTopBarItem {
  cursor: pointer;
}
.element {
  width: 300px;
  height: 510px;
  background: #f8f8f8;
  margin: 10px;
  padding: 10px;
}

.element .title {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}

.addTopBarItem {
  text-align: center;
  line-height: 410px;
  background: #f8f8f8;
}

.bottomBar {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 999;
  padding: 10px;
  width: calc(100%);
  border-top: 1px solid #f8f8f8;
}
</style>
